export default [
    {
        "name": "Revenue 收入",
        "key": "Revenue 收入",
        "sort": 0,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "a. Room Revenue 客房收入",
        "key": "a. Room Revenue 客房收入",
        "sort": 1,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "OCC%出租率",
        "key": "OCC%出租率",
        "sort": 2,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "ADR平均房价",
        "key": "ADR平均房价",
        "sort": 3,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "RevPar单房收益",
        "key": "RevPar单房收益",
        "sort": 4,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "b. F&B Revenue 餐饮收入",
        "key": "b. F&B Revenue 餐饮收入",
        "sort": 5,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "F&B Dep't Profit % 餐饮部门利润率",
        "key": "F&B Dep't Profit % 餐饮部门利润率",
        "sort": 6,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Banquet Revenue 宴会收入",
        "key": "Banquet Revenue 宴会收入",
        "sort": 7,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "CR Revenue 中餐厅收入",
        "key": "CR Revenue 中餐厅收入",
        "sort": 8,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "—A/C人均消费",
        "key": "—A/C人均消费",
        "sort": 9,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "—Covers 就餐人数",
        "key": "—Covers 就餐人数",
        "sort": 10,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "ADD Revenue 收入",
        "key": "ADD Revenue 收入",
        "sort": 11,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "—A/C 人均消费",
        "key": "—A/C 人均消费",
        "sort": 12,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "—Covers 就餐人数",
        "key": "—Covers 就餐人数",
        "sort": 13,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "SR  Revenue 特色餐厅收入",
        "key": "SR  Revenue 特色餐厅收入",
        "sort": 14,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "LB  Revenue 大堂吧收入",
        "key": "LB  Revenue 大堂吧收入",
        "sort": 15,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "RS  Revenue 客房送餐收入",
        "key": "RS  Revenue 客房送餐收入",
        "sort": 16,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "c. Other Revenue 其他收入",
        "key": "c. Other Revenue 其他收入",
        "sort": 17,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "d.Total Revenue 总收入",
        "key": "d.Total Revenue 总收入",
        "sort": 18,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "GOP 利润",
        "key": "GOP 利润",
        "sort": 19,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "a. Payroll Cost 人力成本",
        "key": "a. Payroll Cost 人力成本",
        "sort": 20,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "% 人力成本率",
        "key": "% 人力成本率",
        "sort": 21,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "b. Utility Cost 能耗成本",
        "key": "b. Utility Cost 能耗成本",
        "sort": 22,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "% 能耗成本率",
        "key": "% 能耗成本率",
        "sort": 23,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "（仅使用于能耗成本指标以下内容）",
        "key": "（仅使用于能耗成本指标以下内容）",
        "sort": 24,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "OCC% 出租率",
        "key": "OCC% 出租率",
        "sort": 25,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "F&B Revenue 餐饮收入",
        "key": "F&B Revenue 餐饮收入",
        "sort": 26,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Electricity 用电量  (KWH)",
        "key": "Electricity 用电量  (KWH)",
        "sort": 27,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Water 用水量 (m³ )",
        "key": "Water 用水量 (m³ )",
        "sort": 28,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Gas 燃气用量 (m³ )",
        "key": "Gas 燃气用量 (m³ )",
        "sort": 29,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Steam 蒸汽用量 (m³ )",
        "key": "Steam 蒸汽用量 (m³ )",
        "sort": 30,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "c. F&B Cost 餐饮成本",
        "key": "c. F&B Cost 餐饮成本",
        "sort": 31,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "% 餐饮成本率",
        "key": "% 餐饮成本率",
        "sort": 32,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "餐饮收入",
        "key": "餐饮收入",
        "sort": 33,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Banquet Revenue 宴会收入（仅餐厅）",
        "key": "Banquet Revenue 宴会收入（仅餐厅）",
        "sort": 34,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "—成本百分比 Cost %",
        "key": "—成本百分比 Cost %",
        "sort": 35,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "CR Revenue 中餐厅收入",
        "key": "CR Revenue 中餐厅收入",
        "sort": 36,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "—成本百分比 Cost %",
        "key": "—成本百分比 Cost %",
        "sort": 37,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "ADD Revenue 收入",
        "key": "Revenue 收入",
        "sort": 38,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "—成本百分比 Cost %",
        "key": "—成本百分比 Cost %",
        "sort": 39,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "SR  Revenue 特色餐厅收入",
        "key": "SR  Revenue 特色餐厅收入",
        "sort": 40,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "—成本百分比 Cost %",
        "key": "—成本百分比 Cost %",
        "sort": 41,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "是否参与HACCP审核",
        "key": "是否参与HACCP审核",
        "sort": 42,
        "m_act": "",
        "m_bud": 0,
        "m_var": 0,
        "y_act": "",
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "d. GOP 总毛利润",
        "key": "d. GOP 总毛利润",
        "sort": 43,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "GOP% 总毛利率",
        "key": "GOP% 总毛利率",
        "sort": 44,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "e. Flow Through 边际盈利率",
        "key": "e. Flow Through 边际盈利率",
        "sort": 45,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Guest Satisfaction 客户满意度",
        "key": "Guest Satisfaction 客户满意度",
        "sort": 46,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "a. Score 华客OTA平均点评分",
        "key": "a. Score 华客OTA平均点评分",
        "sort": 47,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Number 评论数",
        "key": "Number 评论数",
        "sort": 48,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "b. 是否完成神秘访客计划",
        "key": "b. 是否完成神秘访客计划",
        "sort": 49,
        "m_act": "",
        "m_bud": 0,
        "m_var": 0,
        "y_act": "",
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Club GCH 豪廷會",
        "key": "Club GCH 豪廷會",
        "sort": 50,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Club GCH 128 Member 豪廷會128会员售卖",
        "key": "Club GCH 128 Member 豪廷會128会员售卖",
        "sort": 51,
        "m_act": 0,
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    },
    {
        "name": "Action Taken by Hotel 酒店提升行动",
        "key": "Action Taken by Hotel 酒店提升行动",
        "sort": 52,
        "m_act": "",
        "m_bud": 0,
        "m_var": 0,
        "y_act": 0,
        "y_bud": 0,
        "y_var": 0
    }
]


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/monthlyReview/data.js